/** @jsx jsx */
import { jsx, css } from "@emotion/core";

import Section from "./Section";

// routes
import Home from "./routes/Home";

const styles = css`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 140px;

  @media (max-width: 768px) {
    margin-top: 100px;
  }

  @media (max-width: 480px) {
    margin-top: 80px;
    padding-bottom: 80px;
  }
`;

const Main = () => (
  <main css={styles}>
    <Section>
      <Home />
    </Section>
  </main>
);

export default Main;
